'use client'

import { Link } from '@/shared/i18n'
import { stringSVGToDataURI } from '@/shared/lib'
import { Button, Icon, Popover } from '@/shared/ui'

import { Background } from './background'

export const RoomRegistration = () => {
  return (
    <div
      className="host-room-registration-slim-banner flex items-center justify-between rounded-lg p-5"
      style={{
        backgroundImage: `url("${stringSVGToDataURI(Background)}")`,
      }}
    >
      <p className="typo-headline3 font-semibold text-white">
        방 등록하고 전담 컨설턴트의 1:1 맞춤 안내를 받으세요
      </p>
      <Popover.Root defaultOpen>
        <Popover.Anchor asChild>
          <Button
            color="secondary"
            size="large"
            shape="pill"
            className="w-50 gap-1.5"
            asChild
          >
            <Link href="/host/room/update">
              <Icon name="plus" strokeWidth={1.5} size={16} />방 등록하기
            </Link>
          </Button>
        </Popover.Anchor>
        <Popover.Content
          color="purple"
          side="bottom"
          sideOffset={4}
          onInteractOutside={e => {
            e.preventDefault()
          }}
          onEscapeKeyDown={e => {
            e.preventDefault()
          }}
        >
          빠르게 공실을 해결해 보세요
        </Popover.Content>
      </Popover.Root>
    </div>
  )
}
